/*! burgopak 2016-11-23 */
(function (window, document, $) {
$(document).ready(function() {
	BGP.nav.init();
	if ($(".js--pack-list").length > 0) {
		BGP.packFilter.init();
	}
	if ($(".js--slides").length > 0) {
		BGP.slider.init();
	}
	if ($(".js--data-collection").length > 0) {
		BGP.dataCollection.init();
	}
	if ($(".js--header-arrow").length > 0 && $(".js--scroll-to").length > 0) {
		$(".js--header-arrow").on("click", function() {
			var scrollTo = $(".js--scroll-to").offset().top;
			$("html, body").animate({
				scrollTop: scrollTo
			});
		});
	}
	$("a[rel=external]").on("click", function(e) {
		e.preventDefault();
		var href = $(e.target).attr("href");
		window.open(href);
	});
});

var BGP = BGP || {};

BGP.nav = function() {
	function init() {
		var $toggle = $(".js--nav-toggle"),
			$toggleClose = $(".js--nav-toggle-close"),
			$navWrapper = $(".js--nav-wrapper"),
			$logo = $(".js--nav-logo"),
			$nav = $(".js--nav"),
			$navInner = $(".nav--inner");
		$(".js--nav-toggle, .js--nav-toggle-close").on("click", function(e) {
			e.preventDefault();
			$nav.toggleClass("nav__open");
			$toggleClose.toggleClass("show");
			$toggle.toggleClass("show");
			$navInner.toggleClass("show");
		});
		$(window).on("scroll", function() {
			if (window.scrollY > 0) {
				$navWrapper.addClass("nav__scrolled");
			} else {
				$navWrapper.removeClass("nav__scrolled");
			}
			if (window.scrollY > 40) {
				$logo.addClass("js--show");
			} else {
				$logo.removeClass("js--show");
			}
		});
	}
	return {
		init: init
	};
}();

var BGP = BGP || {};

BGP.packFilter = function() {
	var $filterToggle, $filtersWrapper, $filters, $empty, $clearFilters, $packList, $packs;
	function init() {
		$filterToggle = $(".js--pack-filter-toggle");
		$filters = $(".js--pack-filter-filters li");
		$filtersWrapper = $(".js--pack-filter-filters");
		$clearFilters = $(".js--pack-filter-clear");
		$packList = $(".js--pack-list");
		$packs = $(".js--pack");
		$empty = $(".js--pack-empty");
		$filtersWrapper.hide();
		$clearFilters.hide();
		$empty.hide();
		if ($(".pack-filter")) {
			bind();
		}
		addSpacers($packs.length);
		if (window.location.hash.length > 1) {
			var mech = window.location.hash.replace("#", " ");
			var mechFilter = $(".js--pack-filter-filters li[data-filter=" + mech + "]");
			if (mechFilter.length > 0) {
				mechFilter.trigger("click");
				$filtersWrapper.show();
			}
		}
	}
	function bind() {
		$filterToggle.on("click", function(e) {
			e.preventDefault();
			$filtersWrapper.toggle();
			$clearFilters.toggle();
		});
		$filters.on("click", function(e) {
			e.preventDefault();
			var $target = $(e.target).closest("li");
			toggleFilter($target);
			if ($target.hasClass("js--single-select")) {
				var $clear = $(".js--single-select").not($target);
				$clear.each(function(index, filter) {
					toggleFilter($(filter), true);
				});
			}
			filterPacks();
		});
		$clearFilters.on("click", function(e) {
			e.preventDefault();
			$filters.each(function(index, filter) {
				toggleFilter($(filter), true);
			});
			filterPacks();
		});
	}
	function toggleFilter($filter, clear) {
		var newIconClass = "", $icon = $filter.find("i");
		switch ($icon.attr("class")) {
			case "fa fa-circle-o":
				if (clear) {
					newIconClass = "fa fa-circle-o";
				} else {
					newIconClass = "fa fa-circle";
				}
				break;

			case "fa fa-circle":
				newIconClass = "fa fa-circle-o";
				break;

			case "fa fa-square-o":
				if (clear) {
					newIconClass = "fa fa-square-o";
				} else {
					newIconClass = "fa fa-check-square";
				}
				break;

			case "fa fa-check-square":
				newIconClass = "fa fa-square-o";
				break;
		}
		$icon.removeClass();
		$icon.addClass(newIconClass);
		if (clear) {
			$filter.removeClass("active");
		} else {
			$filter.toggleClass("active");
		}
	}
	function filterPacks() {
		var filters = $filters.filter(".active").map(function(index, elem) {
			return $(elem).data("filter");
		}).toArray();
		$empty.hide();
		var toShow = [];
		$packs.hide();
		$(".js--pack-spacer").remove();
		$packs.each(function(index, elem) {
			var $elem = $(elem), types = $elem.data("filter").trim().split(" "), show = true;
			for (var i = filters.length - 1; i >= 0; i--) {
				if (types.indexOf(filters[i]) < 0) {
					show = false;
				}
			}
			if (show) {
				toShow.push(elem);
			}
		});
		if (toShow.length > 0) {
			addSpacers(toShow.length);
			$empty.hide();
			$(toShow).delay(200).fadeIn("fast");
		} else {
			$empty.show();
		}
	}
	function addSpacers(count) {
		if (count / 3 % 1 !== 0) {
			var toAdd = 3 - count % 3;
			for (var i = toAdd; i >= 1; i--) {
				$packList.append('<div class="pack-list--item js--pack-spacer"></div>');
			}
		}
	}
	return {
		init: init
	};
}();

var BGP = BGP || {};

BGP.slider = function() {
	var $slides, $slidesPagination;
	function init() {
		$slides = $(".js--slides");
		$slidesPagination = $(".js--slides-pagination");
		if ($slides.find("li").length > 1) {
			bind();
		} else {
			$slidesPagination.hide();
			$(".js--slider-prev, .js--slider-next").hide();
		}
	}
	function bind() {
		$slides.flexslider({
			animation: "slide",
			useCSS: true,
			allowOneSlide: true,
			after: changed,
			initDelay: 0,
			slideshow: false,
			slideshowSpeed: 4e3
		});
		$(".js--slider-prev").on("click", function(e) {
			e.preventDefault();
			$slides.flexslider("prev");
		});
		$(".js--slider-next").on("click", function(e) {
			e.preventDefault();
			$slides.flexslider("next");
		});
		$slidesPagination.on("click", function(e) {
			e.preventDefault();
			var slide = $(e.target).closest("a").data("slide");
			$slides.flexslider(slide);
		});
	}
	function changed(slider) {
		$slidesPagination.removeClass("active");
		$(".js--slides-pagination[data-slide=" + slider.currentSlide + "]").addClass("active");
	}
	return {
		init: init
	};
}();

var BGP = BGP || {};

BGP.dataCollection = function() {
	var $links, $body, brochureLink, template, $modal, $form;
	function init() {
		$links = $(".js--data-collection");
		$body = $("body");
		template = $("#js--data-collection-template").html();
		bind();
	}
	function bind() {
		$links.on("click", function(e) {
			e.preventDefault();
			brochureLink = $(e.target).attr("href");
			$modal = $(template);
			$body.append($modal);
			$form = $modal.find(".form");
			bindModal();
		});
	}
	function bindModal() {
		$modal.find(".js--close").on("click", function(e) {
			e.preventDefault();
			$modal.remove();
		});
		$modal.find(".js--skip").on("click", function(e) {
			e.preventDefault();
			openBrochure();
		});
		$modal.find(".js--submit").on("click", function(e) {
			e.preventDefault();
			$modal.find(".js--error").hide();
			if (!$form[0].checkValidity()) {
				showError();
			} else {
				openBrochure();
				$.post("/signup", {
					email: $modal.find("input[name=email]").val(),
					brochure_url: brochureLink
				}).done(function(response) {
					$modal.remove();
				}).fail(function(response) {
					showError();
				});
			}
		});
	}
	function openBrochure() {
		window.open(brochureLink);
	}
	function showError() {
		$modal.find(".js--error").css({
			display: "inline-block"
		});
	}
	return {
		init: init
	};
}();
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./assets/scripts/legacy.js